var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { PureComponent } from 'react';
import compose from 'recompose/compose';
import { injectIntl } from 'react-intl';
import WithValidation from '../../lib/WithValidation';
import require from '../../lib/WithValidation/rules/required';
import number from '../../lib/WithValidation/rules/number';
import AccordionWidget from '../AccordionWidget';
import AmountItemHeader from './AmountItemHeader';
import AmountItemContent from './AmountItemContent';
import { ActiveLimit } from './LimitStatus';
import translate from '../../lib/utils/translate';

var ResponsibleGaming = function (_PureComponent) {
  _inherits(ResponsibleGaming, _PureComponent);

  function ResponsibleGaming(props) {
    _classCallCheck(this, ResponsibleGaming);

    var _this = _possibleConstructorReturn(this, (ResponsibleGaming.__proto__ || Object.getPrototypeOf(ResponsibleGaming)).call(this, props));

    _this._handleType = function (item) {
      var data = _this.props.data;


      _this.setState({
        expandedIndex: data.indexOf(item),
        type: item.action,
        timespan: 1,
        amount: null,
        submitButton: false
      });

      if (data.indexOf(item) === _this.state.expandedIndex) {
        _this.setState({
          expandedIndex: null
        });
      }
    };

    _this.handleLimitAmount = function (e) {
      if (e.currentTarget.value <= 0) {
        _this.setState({
          amount: parseInt(1),
          submitButton: true
        });
      } else {
        _this.setState({
          amount: parseInt(e.currentTarget.value),
          submitButton: true
        });
      }
    };

    _this.handleLimitTimespan = function (item) {
      _this.setState({
        timespan: item.value
      }, function () {
        return _this.handleTimespanAmounts();
      });
    };

    _this.handleTimespanAmounts = function () {
      _this.setState({
        amount: null,
        submitButton: false
      });
    };

    _this.handleDecrement = function () {
      if (_this.state.amount > 1) {
        _this.setState({
          amount: parseInt(_this.state.amount / 2),
          submitButton: true
        });
      }
    };

    _this.handleIncrement = function () {
      var amount = _this.state.amount;


      _this.setState({
        amount: amount ? parseInt(amount * 2) : 1000,
        submitButton: true
      });
    };

    _this.state = {
      type: props.data && props.data[0].action
    };
    return _this;
  }

  _createClass(ResponsibleGaming, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          intl = _props.intl,
          onSubmit = _props.onSubmit,
          currency = _props.currency,
          limitsData = _props.limitsData,
          onCancel = _props.onCancel;


      var items = data && data.map(function (item, i) {
        if (['Deposit', 'NetLoss', 'Wager', 'LoginTime'].includes(item.action)) {
          return {
            item: item,
            header: React.createElement(AmountItemHeader, {
              content: item.content,
              title: translate({ id: 'label.type.' + item.action }, intl),
              currency: currency,
              type: item.action
            }),
            content: React.createElement(
              'div',
              { className: 'responsiblegaming-limit-item-content' },
              React.createElement(AmountItemContent, _defineProperty({
                type: _this2.state.type,
                currency: currency,
                amount: _this2.state.amount,
                limitsData: limitsData,
                handleDecrement: _this2.handleDecrement,
                handleIncrement: _this2.handleIncrement,
                handleLimitAmount: _this2.handleLimitAmount,
                handleLimitTimespan: _this2.handleLimitTimespan,
                timespan: _this2.state.timespan,
                config: item.config,
                submitButton: _this2.state.submitButton
              }, 'type', _this2.state.type))
            ),
            key: item.action + i
          };
        }
      });

      return React.createElement(
        'div',
        null,
        React.createElement(
          'div',
          { className: 'responsiblegaming-limit-selector' },
          React.createElement(
            'form',
            { onSubmit: onSubmit },
            items && React.createElement(AccordionWidget, {
              items: items,
              onClickHeader: function onClickHeader(e, key, item) {
                return _this2._handleType(item.item);
              }
            })
          )
        ),
        limitsData && limitsData.map(function (limit) {
          var period = '';

          switch (parseInt(limit.Timespan)) {
            case 0:
              period = translate({
                id: 'label.each_transaction',
                defaultMessage: 'Each transaction'
              }, intl);
              break;
            case 1:
              period = translate({
                id: 'label.each_day',
                defaultMessage: 'Each day'
              }, intl);
              break;
            case 7:
              period = translate({
                id: 'label.each_week',
                defaultMessage: 'Each week'
              }, intl);
              break;
            case 30:
              period = translate({
                id: 'label.each_month',
                defaultMessage: 'Each month'
              }, intl);
              break;
            default:
              break;
          }

          return React.createElement(ActiveLimit, {
            amount: limit.Amount,
            type: limit.Type,
            currency: currency,
            key: limit.Id,
            onCancel: onCancel,
            id: limit.Id,
            period: period
          });
        })
      );
    }
  }]);

  return ResponsibleGaming;
}(PureComponent);

var rules = {
  Type: [[require, 'error.empty.type']],
  Timespan: [[require, 'error.empty.timespan']],
  Amount: [[require, number, 'error.number.amount']]
};

export default compose(WithValidation(rules), injectIntl)(ResponsibleGaming);